import { Component } from '@angular/core';

@Component({
  selector: 'app-free-trial-eula',
  standalone: true,
  imports: [],
  templateUrl: './free-trial-eula.component.html',
  styleUrl: './free-trial-eula.component.scss',
})
export class FreeTrialEulaComponent {}
